import { XPType } from "./enum/enum";
import { RankXP } from "./rank";

/** On-chain points that equal 1% of that skill. */
export const KILL_SKILL_XP_PER_PERCENT = 10_000;
export const BUST_OUT_XP_PER_PERCENT = 5_000;
export const RACE_XP_PER_PERCENT = 5_000;

export const SKILL_XP_POINTS_PER_PERCENT = {
  [XPType.KillXP]: KILL_SKILL_XP_PER_PERCENT,
  [XPType.BustXP]: BUST_OUT_XP_PER_PERCENT,
  [XPType.RaceXP]: RACE_XP_PER_PERCENT,
} as const;

const rankXpSpan = (rankNumber: number) =>
  RankXP[rankNumber] - RankXP[rankNumber - 1];

export const XP_EARNED_PERCENT = (xpAmount: number, rankNumber: number) => {
  return (xpAmount / rankXpSpan(rankNumber)) * 100;
};

export const TRAVEL_XP_EARNED = (rankNumber: number) => {
  const travelXp = 2 * 50; // 50x increased
  return ((travelXp / rankXpSpan(rankNumber)) * 10000).toFixed(2);
};
